import apiCall from "./apiCall";

const getDataPrivilegeByRole = async (roleId: string) => {
    const URL = `/Privilege/GetDataPrivilegesByRole?roleId=${roleId}`;
    return apiCall('get', URL);
};

const getDataPrivilegeByUser = async (userId: string) => {
    const URL = `/Privilege/GetDataPrivilegesByUser?userid=${userId}`;
    return apiCall('get', URL);
};

const postAssignPrivilegeToRole = async (data: any) => {
    const URL = '/Privilege/AssignRevokePrivilegeRole';
    return apiCall('post', URL, data);
};

const postAssignPrivilegeToUser = async (data: any) => {
    const URL = '/Privilege/AssignRevokePrivilegeUser';
    return apiCall('post', URL, data);
};

export {
    getDataPrivilegeByRole,
    getDataPrivilegeByUser,
    postAssignPrivilegeToRole,
    postAssignPrivilegeToUser
};
